<body>
  <div class="flex-justify-center flex-align-it-end">
    <h3 i18n="@@redirected">You are being redirected, please, wait...</h3>
  </div>
</body>
